<template>
  <div class="layout-footer" style="padding-top:0">
    <div class="grid">
      <div class="col-12" style="text-align: center;padding-right: 5em">
        <a href="/" class="logo-container">
          <img src="assets/layout/images/logo-coface-RVB.png" alt="logo-coface-RVB.png"/>
        </a>
      </div>
      <div class="col-12" style="padding:0em 2em 0 5em;padding-right: 5em;text-align: justify">
				<span style="color: #1c355e; font-size: 9px; font-style: italic">
          {{$t('footer.legal')}}
				</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppFooter"
}
</script>

<style scoped>

</style>
